import styled from 'styled-components'
import { COLORS } from '../../constants'

export const Container = styled.div`
  width: 95%;
  height: 10rem;
  min-height: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${COLORS.primary};
  margin: 2rem 0 1rem 0;
  padding: 1rem 0;
  border-radius: 8px;
`

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: bold;
  color: ${COLORS.gray};
  margin-bottom: 2rem;
`

export const WrapperContainerBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 1.5rem;
  margin-left: 4rem;
`

export const ContainerBar = styled.div`
  justify-content: center;
  width: 20rem;
  height: 2rem;
  background-color: ${COLORS.gray};
  overflow: hidden;
  border-radius: 8px;
`

export const Fill = styled.div<{ $percentage: number; $color: string }>`
  height: 100%;
  background-color: ${({ $color }) => $color};
  width: ${({ $percentage }) => $percentage}%;
`

export const Message = styled.p`
  font-size: 1.5rem;
  color: ${COLORS.gray};
`
export const CurrentLoad = styled.p`
  font-size: 1.2rem;
  color: ${COLORS.gray};
  margin-left: 1rem;
`
